import { render, staticRenderFns } from "./GuestModal.vue?vue&type=template&id=047bc09c&lang=pug"
import script from "./GuestModal.vue?vue&type=script&lang=ts"
export * from "./GuestModal.vue?vue&type=script&lang=ts"
import style0 from "./GuestModal.vue?vue&type=style&index=0&id=047bc09c&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports